/**
 * Program Milestone Dashboard Selector
 * Allows user to select a program, then displays the incentive dashboard
 * Uses shared ProgramSelector for consistent data isolation
 * Trust Marketplace - Configurable Milestone System
 */

import React, { useState } from 'react';
import { Card } from '../ui/card';
import ProgramSelector from '../shared/ProgramSelector';
import ProgramIncentiveDashboard from './ProgramIncentiveDashboard';

import { useAppTranslation } from '@/contexts/TranslationContext';
const ProgramMilestoneDashboardSelector: React.FC = () => {
  const { t } = useAppTranslation();
  const [selectedProgramId, setSelectedProgramId] = useState<number | null>(null);

  return (
    <div className="space-y-6">
      {/* Program Selector - using shared component with data isolation */}
      <Card className="p-6">
        <ProgramSelector
          selectedProgramId={selectedProgramId}
          onProgramChange={setSelectedProgramId}
          label={t('incentives.select_program', 'Select Program')}
        />
      </Card>

      {/* Dashboard */}
      {selectedProgramId && (
        <ProgramIncentiveDashboard programId={selectedProgramId} />
      )}
    </div>
  );
};

export default ProgramMilestoneDashboardSelector;
